<template>
    <div>
        <div class="card">
            <div class="card-body">
                <h4>Información Académica</h4>
                <p class="text-muted">Registra las especialidades académicas que aparecerán en los documentos generados por el sistema.</p>
                <div v-if="specialties.length > 0">
                    <ul class="list-group">
                        <li v-for="specialty in specialties" :key="specialty.id" class="list-group-item">
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <span class="fw-light"><strong>Especialidad:</strong> {{ specialty.nombre_especialidad }}</span><br>
                                    <span class="fw-light"><strong>Institución:</strong> {{ specialty.institucion_especialidad }}</span><br>
                                    <span class="fw-light"><strong>Cédula Profesional:</strong> {{ specialty.cedula_profesional }}</span>
                                    <p v-if="specialty.enDocumentos" class="smallText">🟢 Se usa en documentación</p>
                                </div>
                                <div class="text-end">
                                    <a href="#" class="text-center smallText me-2" @click="editSpecialty(specialty)">✏️Editar</a>
                                    <a href="#" class="text-center smallText" @click="deleteSpecialty(specialty.id)">🗑️Eliminar</a>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="form-group">
                    <label for="nombreEspecialidad">Nombre de la Especialidad</label>
                    <input type="text" id="nombreEspecialidad" v-model="newSpecialty.nombre_especialidad" class="form-control" placeholder="Ejemplo: Cardiología" required />
                </div>
                <div class="form-group">
                    <label for="institucionEspecialidad">Institución</label>
                    <input type="text" id="institucionEspecialidad" v-model="newSpecialty.institucion_especialidad" class="form-control" placeholder="Ejemplo: UNAM" required />
                </div>
                <div class="form-group">
                    <label for="cedulaProfesional">Cédula Profesional</label>
                    <input type="text" id="cedulaProfesional" v-model="newSpecialty.cedula_profesional" class="form-control" placeholder="Ejemplo: 1234567" required />
                </div>
                <div class="form-group">
                    <label>
                        <input type="checkbox" v-model="newSpecialty.enDocumentos" /> Mostrar en documentos
                    </label>
                </div>
                <vs-button @click="createSpecialty" color="rgb(59,222,200)" gradient block>
                    {{ editingSpecialtyId ? "✏️ Actualizar Especialidad" : "💾 Guardar Especialidad" }}
                </vs-button>
                <hr />
                <div class="col-md-12 text-center">
                    <a class="smallText" @click="resetForm" href="#">Limpiar formulario</a>
                </div>

            </div>
        </div>

        <vs-dialog v-model="showDeleteDialog" title="Confirmar Eliminación" class="custom-dialog">
            <div class="container">
                <div class="row mb-3 mt-3">
                    <div class="col-md-12 text-center">
                        <span class="material-icons md-48 text-danger">warning</span>
                        <h4>Eliminar Especialidad</h4>
                        <p>¿Estás seguro que deseas eliminar la especialidad <strong>{{ specialtyToDelete?.nombre_especialidad }}</strong>?</p>
                        <div class="d-flex justify-content-center gap-3">
                            <vs-button @click="confirmDeleteSpecialty" color="rgb(59,222,200)" gradient>
                                Sí, deseo continuar
                            </vs-button>
                            <vs-button @click="showDeleteDialog = false" color="rgb(255,77,77)" gradient>
                                Cancelar
                            </vs-button>
                        </div>
                    </div>
                </div>
            </div>
        </vs-dialog>
    </div>
</template>

<script>
    import axios from "axios";
    var config = require("@/config/api.json");
    const API = config.api;

    export default {
        name: "PersonalMedicoInfoAcademica",
        props: {
            personal_medico_id: {
                type: Number,
                required: true,
            },
        },
        data() {
            return {
                specialties: [],
                newSpecialty: {
                    nombre_especialidad: "",
                    institucion_especialidad: "",
                    cedula_profesional: "",
                    enDocumentos: false,
                },
                editingSpecialtyId: null, // Track the specialty being edited
                showDeleteDialog: false, // Controls the visibility of the delete confirmation dialog
                specialtyToDelete: null, // Stores the specialty to be deleted
            };
        },
        mounted() {
            this.fetchSpecialties();
        },
        methods: {
            async fetchSpecialties() {
            try {
                const response = await axios.get(`${API}/listar_especialidades`, {
                params: { personal_medico_id: this.personal_medico_id },
                });
                if (response.data.status === "success") {
                this.specialties = response.data.data;
                } else {
                this.notify("error", response.data.message);
                }
            } catch (error) {
                console.error("Error al listar especialidades:", error);
                this.notify("error", "Error al listar las especialidades.");
            }
            },
            editSpecialty(specialty) {
            this.editingSpecialtyId = specialty.id;
            this.newSpecialty = { ...specialty };
            },
            async createSpecialty() {
            if (!this.newSpecialty.nombre_especialidad || !this.newSpecialty.institucion_especialidad || !this.newSpecialty.cedula_profesional) {
                this.notify("error", "Por favor completa todos los campos requeridos.");
                return;
            }

            try {
                const payload = {
                personal_medico_id: this.personal_medico_id,
                ...this.newSpecialty,
                };

                let response;
                if (this.editingSpecialtyId) {
                if (this.specialties.length === 1 && !this.newSpecialty.enDocumentos) {
                    this.notify("error", "Debe tener al menos una especialidad ligada a documentos.");
                    return;
                }
                response = await axios.put(`${API}/actualizar_especialidad/${this.editingSpecialtyId}`, payload);
                } else {
                response = await axios.post(`${API}/crear_especialidad`, payload);
                }

                if (response.data.status === "success") {
                this.notify("success", this.editingSpecialtyId ? "Especialidad actualizada exitosamente." : "Especialidad creada exitosamente.");

                await this.callAudit(this.personal_medico_id, this.editingSpecialtyId ? "ACTUALIZAR" : "CREAR", "personal_medico_especialidad", this.editingSpecialtyId ? this.editingSpecialtyId : this.personal_medico_id, this.editingSpecialtyId ? "Actualiza datos de especialidad" : "Crea datos de especialidad");

                this.resetForm();
                this.fetchSpecialties();
                } else {
                this.notify("error", response.data.message);
                }
            } catch (error) {
                console.error("Error al guardar especialidad:", error);
                this.notify("error", "Error al guardar la especialidad.");
            }
            },
            resetForm() {
            this.newSpecialty = {
                nombre_especialidad: "",
                institucion_especialidad: "",
                cedula_profesional: "",
                enDocumentos: false,
            };
            this.editingSpecialtyId = null;
            },
            deleteSpecialty(specialtyId) {
            this.specialtyToDelete = this.specialties.find(specialty => specialty.id === specialtyId);
            this.showDeleteDialog = true;
            },
            async confirmDeleteSpecialty() {
            if (!this.specialtyToDelete) return;

            try {
                const response = await axios.delete(`${API}/eliminar_especialidad/${this.specialtyToDelete.id}`, {
                params: { 
                    personal_medico_id: this.personal_medico_id,
                    enDocumentos: this.specialtyToDelete.enDocumentos,
                },
                });
                if (response.data.status === "success") {
                this.notify("success", "Especialidad eliminada exitosamente.");
                await this.callAudit(this.personal_medico_id, "BORRAR", "personal_medico_especialidad", this.specialtyToDelete.id, "Borra datos de especialidad");
                this.fetchSpecialties();
                } else if (response.data.message === "Debe tener al menos una especialidad registrada") {
                this.notify("error", "Debe tener al menos una especialidad registrada.");
                } else if (response.data.message === "Especialidad no encontrada") {
                this.notify("error", "Especialidad no encontrada.");
                } else {
                this.notify("error", response.data.message);
                }
            } catch (error) {
                console.error("Error al eliminar especialidad:", error);
                this.notify("error", "Debes tener al menos una especialidad registrada");
            } finally {
                this.showDeleteDialog = false;
                this.specialtyToDelete = null;
            }
            },
        },
    };
</script>

<style scoped>
    .list-group-item {
        margin-bottom: 10px;
    }
</style>
